/* tslint:disable */
import {Injectable, Inject, Optional} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SDKModels} from './SDKModels';
import {BaseLoopBackApi, LoopBackAuth, JSONSearchParams, ErrorHandler} from '../core';
import {PaypalPayment} from '../../models';
import {Observable} from 'rxjs';
import {LoopBackConfig} from '../../lb.config';
import {pluck} from 'rxjs/internal/operators';

/**
 * Api services for the `PaypalPayment` model.
 */
@Injectable()
export class PaypalPaymentApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http, models, auth, searchParams, errorHandler);
  }

  /**
   * @param {string[]} ids Идентификаторы выбранных групп.
   * @returns {Observable<string>} payment ID
   */
  public createPayment(ids: string[]): Observable<string> {
    return this.request('POST', [
      LoopBackConfig.getPath(),
      LoopBackConfig.getApiVersion(),
      this.model.getModelDefinition().plural,
      'create'
    ].join('/'), undefined, undefined, {ids})
      .pipe(
        pluck('paymentID')
      );
  }

  /**
   * @param {string} paymentID
   * @param {string} payerID
   * @returns {Observable<any>}
   */
  public executePayment(paymentID: string, payerID: string): Observable<any> {
    return this.request('POST', [
      LoopBackConfig.getPath(),
      LoopBackConfig.getApiVersion(),
      this.model.getModelDefinition().plural,
      'execute'
    ].join('/'), undefined, undefined, {paymentID, payerID});
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `PaypalPayment`.
   */
  public getModelName() {
    return 'PaypalPayment';
  }
}
